export const nameRuleset = { required: true, maxLength: 19 };
export const nameAndSurnameRuleset = { required: true, maxLength: 39 };
export const companyRuleset = { required: true, maxLength: 59 };
export const addressRuleset = { required: true, maxLength: 49 };
export const postalCodeRuleset = { required: true, maxLength: 15 };
export const requiredRule = { required: true };

export const emailRuleset = (msg: string) => ({
  required: true,
  pattern: {
    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
    message: msg,
  },
});
